import { Lock } from "@faire/web/slate/icons/foundation/Lock";
import { Column, Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

export const LoggedOutUnlockWholesalePriceLink: React.FC<{
  hideLockIcon?: boolean;
}> = ({ hideLockIcon }) => {
  return (
    <Column align="flex-start">
      <Spacer size="1x" />
      <LinkCta hideLockIcon={hideLockIcon} />
    </Column>
  );
};

const LinkCta = ({ hideLockIcon }: { hideLockIcon?: boolean }) => (
  <Row align="center">
    {!hideLockIcon ? (
      <>
        <div className="flex h-[16px] w-[16px]">
          {/* Wrap flagIcon in div with explicit height because createSVGIcon 
      uses styled-components and size is not correctly set during SSR. */}
          <Lock lockType="foundation" />
        </div>

        <Spacer width={4} />
      </>
    ) : null}
    <Typography className="underline">
      <StrictLocalMsg
        id="Dob8+8"
        defaultMessage="Unlock wholesale price"
        description={{
          text: "sign up cta for product tiles",
        }}
      />
    </Typography>
  </Row>
);
